<template lang="pug" src="./html/HalfMarathonFaceRecognition.pug"></template>

<script>

  import Vue from 'vue'
  import ArticleItemBase from './ArticleItemBase'

  const HalfMarathonFaceRecognitionBody = () => import(/* webpackChunkName: "half-marathon-face-recognition" */ './HalfMarathonFaceRecognition-Body')

  Vue.component('HalfMarathonFaceRecognitionBody', HalfMarathonFaceRecognitionBody)

  export default {
    extends: ArticleItemBase,
    mounted () {
      this.setBody('HalfMarathonFaceRecognitionBody')
    }
  }
</script>

<style lang="sass" src="./style/ArticleItem.sass"></style>

<style scoped>
    .article-item {
        color: #413f44;
    }
    time {
        color: #7e7a84;
    }
    p.feature {
        color: #1A7254;
    }
</style>

<style>
    #app.half-marathon-face-recognition #top-header {
        background-color: #1A7254;
    }
    #app.half-marathon-face-recognition #load-anim {
        stroke: #1A7254;
    }
</style>
